import { axiosInstance } from "./axiosInstance";

export const getAddresses = async () => {
    const response = await axiosInstance.get("/api/addresses");
    return response.data;
};

export const addAddress = async (data: any) => {
    const response = await axiosInstance.post("/api/addresses", data);
    return response.data;
};

export const setDefaultAddress = async (addressId: number) => {
    const response = await axiosInstance.patch(`/api/addresses/${addressId}/default`);
    return response.data;
};

export const deleteAddress = async (addressId: number) => {
    const response = await axiosInstance.delete(`/api/addresses/${addressId}`);
    return response.data;
};